// extracted by mini-css-extract-plugin
module.exports = {"flag":"TabulatorNav_flag__oiOIX","name":"TabulatorNav_name__V8ofo","container":"TabulatorNav_container__1AOsU"};